import { FC, useState } from 'react';
import { Button, Col, Dropdown, Menu, Row } from 'antd';
import { useQueryState } from 'nuqs';
import { TbDotsVertical, TbEdit, TbTrash } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { buildSearchFilterEnvelope, DropdownMenuPanel, VirtualizedList as List, searchFiltersQuery } from '@/shared';
import RenameResourceModal from '@/shared/components/modals/ResourceActionModals/01-RenameResourceModal';
import DeleteResourceModal from '@/shared/components/modals/ResourceActionModals/03-DeleteResourceModal';
import { CustomFilter } from '@/types';
import { ellipsisStyling } from '@/utilities';

interface CustomFilterListItemProps {
    i: CustomFilter;
}

const CustomFilterListItem: FC<CustomFilterListItemProps> = ({ i }): JSX.Element => {
    const [renameOpen, setRenameOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);

    const [, setFilters] = useQueryState('filters', searchFiltersQuery);

    const { token } = useAntDesignTheme();

    return (
        <>
            <List.Item key={i?.id}>
                <Row style={{ width: '100%' }} wrap={false}>
                    <Col flex='auto'>
                        <Button
                            block
                            size='small'
                            style={{ justifyContent: 'flex-start', ...ellipsisStyling }}
                            // disabled={i?.query}
                            onClick={() => {
                                setFilters(buildSearchFilterEnvelope(i?.query));
                            }}
                            icon={
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='1rem'
                                    height='1rem'
                                    viewBox='0 0 24 24'
                                    fill='none'
                                    stroke='currentColor'
                                    strokeWidth='2'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    className='icon icon-tabler icons-tabler-outline icon-tabler-filter-2-bolt'
                                >
                                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                    <path d='M4 6h16' />
                                    <path d='M6 12h12' />
                                    <path d='M9 18h4' />
                                    <path d='M19 16l-2 3h4l-2 3' />
                                </svg>
                            }
                        >
                            {i?.title}
                        </Button>
                    </Col>
                    <Col flex='none' style={{ marginLeft: '0.5rem' }}>
                        <Dropdown
                            trigger={['click']}
                            placement='bottomRight'
                            popupRender={() => (
                                <DropdownMenuPanel>
                                    <Menu.Item
                                        key='rename'
                                        icon={<TbEdit size='1rem' />}
                                        onClick={() => {
                                            setRenameOpen(true);
                                        }}
                                    >
                                        Rename
                                    </Menu.Item>
                                    <Menu.Divider />
                                    <Menu.Item
                                        key='delete'
                                        danger
                                        icon={<TbTrash size='1rem' />}
                                        onClick={() => {
                                            setDeleteOpen(true);
                                        }}
                                    >
                                        Delete
                                    </Menu.Item>
                                </DropdownMenuPanel>
                            )}
                        >
                            <Button size='small'>
                                <TbDotsVertical style={{ color: token.colorTextTertiary }} />
                            </Button>
                        </Dropdown>
                    </Col>
                </Row>
            </List.Item>
            <RenameResourceModal
                resource={i}
                singularResource={'custom-filter'}
                open={renameOpen}
                setOpen={setRenameOpen}
            />
            <DeleteResourceModal
                resource={i}
                singularResource={'custom-filter'}
                open={deleteOpen}
                setOpen={setDeleteOpen}
            />
        </>
    );
};

export default CustomFilterListItem;
